import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import type { InfluencerCampaignFilter } from "@/marketing/models/influencerCampaign";
import { influencerCampaignAPIClient } from "../influencerCampaignAPIClient";
import { INFLUENCER_CAMPAIGN_KEYS } from "./keys";

export const INFLUENCER_CAMPAIGN_QUERIES = {
  list: (filter: InfluencerCampaignFilter = {}) =>
    queryOptions({
      queryKey: INFLUENCER_CAMPAIGN_KEYS.list(filter),
      queryFn: () =>
        influencerCampaignAPIClient.listInfluencerCampaigns(filter),
      placeholderData: keepPreviousData,
      staleTime: 30 * 1000,
    }),
  tracker: () =>
    queryOptions({
      queryKey: INFLUENCER_CAMPAIGN_KEYS.tracker(),
      queryFn: () => influencerCampaignAPIClient.listAllInfluencerCampaigns(),
      staleTime: 30 * 1000,
    }),
  detail: (campaignId: string) =>
    queryOptions({
      queryKey: INFLUENCER_CAMPAIGN_KEYS.detail(campaignId),
      queryFn: () =>
        influencerCampaignAPIClient.getInfluencerCampaign(campaignId),
      staleTime: 60 * 1000,
      enabled: campaignId !== "",
    }),
  stockSource: (campaignId: string) =>
    queryOptions({
      queryKey: INFLUENCER_CAMPAIGN_KEYS.stockSource(campaignId),
      queryFn: () =>
        influencerCampaignAPIClient.getInfluencerCampaignStockSource(campaignId),
      staleTime: 60 * 1000,
      // A missed read is shown as one, never guessed as FF2 stock; retrying a 404 or 409 only delays saying so.
      retry: false,
      enabled: campaignId !== "",
    }),
};
